// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3f_Xj","addWidgetButton":"Header_addWidgetButton__1at50","dashboardTabs":"Header_dashboardTabs__sdEvi","active":"Header_active__I3XhK"};